import { TPAComponentProps } from '../../types';

export enum SpinnerTypes {
  regular = 'regular',
  slim = 'slim',
}

export interface SpinnerProps extends TPAComponentProps {
  type?: SpinnerTypes;
  diameter?: number;
  isCentered?: boolean;
  isStatic?: boolean;
  'aria-label'?: string;
}

export interface SpinnerDefaultProps {
  type: SpinnerTypes;
  diameter?: number;
  isCentered: boolean;
  isStatic: boolean;
}

export interface SpinnerState {}
